import { FxIdDomainEntitiesAghanimPaymentStatus, StoreApi } from "@app/Api/gen";
import { waitFor } from 'poll-until-promise';

export async function waitForAghanimPayment(
    storeApi: StoreApi,
    publicOrderId: string,
    options: {
        interval?: number;
        timeout?: number;
    } = {}
): Promise<FxIdDomainEntitiesAghanimPaymentStatus> {
    const { interval = 1000, timeout = 60000 } = options;

    const result = await waitFor(
        async () => {
            const result = await storeApi.fxIdWebFeaturesStoreAghanimPaymentStatusPaymentStatusEndpoint(publicOrderId);
            if (result.Status === FxIdDomainEntitiesAghanimPaymentStatus.Payed) {
                return result;
            }
            throw new Error('Payment not completed');
        },
        { interval, timeout }
    );

    return result.Status;
} 